import { render } from "./ProposalOverview.vue?vue&type=template&id=d22c9c04"
import script from "./ProposalOverview.vue?vue&type=script&lang=js"
export * from "./ProposalOverview.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jirizavadil/dev/tumorshot-web/app/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])